import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

/**
 * POSHeader - Cabeçalho compartilhado para todas as telas do POS
 */
export function POSHeader({ title, onBack, icon: Icon, rightContent }) {
  return (
    <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white px-4 py-3 flex items-center gap-3 shadow-lg">
      {onBack && (
        <Button variant="ghost" size="icon" onClick={onBack} className="text-white hover:bg-white/10 h-9 w-9">
          <ArrowLeft className="w-5 h-5" />
        </Button>
      )}
      {Icon && <Icon className="w-5 h-5 text-emerald-400" />}
      <h1 className="font-bold text-lg flex-1">{title}</h1>
      {rightContent}
    </div>
  );
}

/**
 * POSHome - Tela inicial do POS com navegação
 */
export function POSHome({ onNavigate, restaurantName, caixaAberto }) {
  const menuItems = [
    { id: "venda", label: "VENDA DIRETA", icon: "🛒", color: "from-emerald-500 to-emerald-600", desc: "Venda rápida no balcão" },
    { id: "contas", label: "CONTAS / MESAS", icon: "🪑", color: "from-blue-500 to-blue-600", desc: "Gestão de mesas" },
    { id: "pedidos", label: "PEDIDOS", icon: "📋", color: "from-purple-500 to-purple-600", desc: "Pedidos do dia" },
    { id: "pagamentos", label: "PAGAMENTOS", icon: "💳", color: "from-amber-500 to-amber-600", desc: "Pagamentos do dia" },
    { id: "recibos", label: "RECIBOS", icon: "🧾", color: "from-pink-500 to-pink-600", desc: "Reimprimir recibos" },
    { id: "autoatendimento", label: "BALCÃO", icon: "📱", color: "from-cyan-500 to-cyan-600", desc: "Modo balcão" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <POSHeader title={restaurantName || "POS"} />
      
      {/* Status do Caixa */}
      <div className="px-4 py-3">
        <div className={`rounded-lg p-3 flex items-center justify-between ${caixaAberto ? "bg-emerald-500/20 border border-emerald-500/30" : "bg-red-500/20 border border-red-500/30"}`}>
          <div className="flex items-center gap-2">
            <div className={`w-3 h-3 rounded-full ${caixaAberto ? "bg-emerald-400 animate-pulse" : "bg-red-400"}`} />
            <span className={`text-sm font-medium ${caixaAberto ? "text-emerald-300" : "text-red-300"}`}>
              {caixaAberto ? "Caixa Aberto" : "Caixa Fechado"}
            </span>
          </div>
          <Button 
            size="sm" 
            variant="ghost" 
            className={caixaAberto ? "text-emerald-300 hover:text-emerald-200" : "text-red-300 hover:text-red-200"}
            onClick={() => onNavigate(caixaAberto ? "fechar-caixa" : "abrir-caixa")}
          >
            {caixaAberto ? "Fechar" : "Abrir"} Caixa
          </Button>
        </div>
      </div>

      {/* Grid de opções */}
      <div className="px-4 pb-4 grid grid-cols-2 sm:grid-cols-3 gap-3">
        {menuItems.map(item => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            disabled={!caixaAberto && item.id !== "autoatendimento"}
            className={`bg-gradient-to-br ${item.color} rounded-xl p-4 text-white text-left transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg disabled:opacity-50 disabled:cursor-not-allowed`}
            data-testid={`pos-nav-${item.id}`}
          >
            <span className="text-3xl block mb-2">{item.icon}</span>
            <span className="font-bold text-sm block">{item.label}</span>
            <span className="text-xs opacity-80">{item.desc}</span>
          </button>
        ))}
      </div>

      {/* Configurações */}
      <div className="px-4 pb-6">
        <button
          onClick={() => onNavigate("config")}
          className="w-full bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl p-4 text-white text-left transition-all flex items-center gap-3"
        >
          <span className="text-2xl">⚙️</span>
          <div>
            <span className="font-bold text-sm block">CONFIGURAÇÕES</span>
            <span className="text-xs opacity-60">Impressora, idioma, tema</span>
          </div>
        </button>
      </div>
    </div>
  );
}
